export default __webpack_public_path__ + "2023 Machine Learning Identification of Organic Compounds Using Visible Light.pdf";